var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "orientation-options", class: 'orientation-options--' + _vm.size }, [_c('el-tooltip', { attrs: { "effect": "dark", "content": _vm.$t('basic.orientationSelector.vertical'), "placement": "bottom", "open-delay": 200 } }, [_c('div', { staticClass: "portrait-option", class: {
      'current': _vm.orientation === 1,
      'is-disabled': _vm.showOrientation.indexOf('portrait') === -1
    }, on: { "click": _vm.changePortrait } })]), _vm._v(" "), _c('el-tooltip', { attrs: { "effect": "dark", "content": _vm.$t('basic.orientationSelector.horizontal'), "placement": "bottom", "open-delay": 200 } }, [_c('div', { staticClass: "landscape-option", class: {
      'current': _vm.orientation === 2,
      'is-disabled': _vm.showOrientation.indexOf('landscape') === -1
    }, on: { "click": _vm.changeLandscape } })])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };